import {
  actions as asyncDataFetch,
  actionTypes as dataFetchActionTypes,
} from '@bufferapp/async-data-fetch';
import { actions as analyticsActions } from '~/analytics-middleware/actions';

export default ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    next(action);
    const state = getState();

    switch (action.type) {
      case `user_${dataFetchActionTypes.FETCH_SUCCESS}`:
        dispatch(
          asyncDataFetch.fetch({
            name: 'globalAccount',
          })
        );
        break;
      default:
        break;
    }
  };
